import React, { useState } from "react";
import { useEffect } from "react";
import NumberFormat from "react-number-format";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import { getAccountsReceivableAgingReport } from "../../../../services/finance/financeReportService";
import Illustration from "../../../../partials/content/Illustration";

function AccountsReceivableAging(props) {
  const { reload } = useGlobalData();
  const [receivableAgingList, setReceivableAgingList] = useState([]);
  useEffect(() => {
    getAccountsReceivableAgingData();
  }, [reload]);
  return (
    <React.Fragment>
      {receivableAgingList.length ? (
        <React.Fragment>
          <CustomDataTable
            data={receivableAgingList}
            onRefreshData={() => {
              getAccountsReceivableAgingData();
            }}
            columns={[
              {
                header: "Customer Name",
                field: "customerName",
                body: (rowData) => (
                  <React.Fragment>
                    <ResponsiveEllipsis
                      text={rowData.customerName}
                      maxLine="1"
                    />
                  </React.Fragment>
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Currency",
                field: "currencyCode",
                body: null,
                sortable: true,
                filter: true,
                hidden: true,
              },
              {
                header: "Current",
                field: "currentAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.currentAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "1 - 30 Days",
                field: "thirtyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.thirtyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "31 - 60 Days",
                field: "sixtyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.sixtyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "61 - 90 Days",
                field: "ninetyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.ninetyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Over 90 Days",
                field: "overNinetyDayAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.overNinetyDayAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
              {
                header: "Total",
                field: "receivableAmount",
                body: (rowData) => (
                  <NumberFormat
                    value={rowData.receivableAmount}
                    displayType={"text"}
                    thousandSeparator={true}
                    decimalScale={2}
                    renderText={(value) => (
                      <div className="float-right">
                        {rowData.currencyCode} {value}
                      </div>
                    )}
                  />
                ),
                sortable: true,
                filter: true,
              },
            ]}
          />
        </React.Fragment>
      ) : (
        <React.Fragment>
          <Illustration
            imageSource="INVIFO Payment.png"
            description="You don't have any Accounts Receivable data yet"
            guidance="Hint: once the Customer is created, it will be displayed here"
            descriptionLeftIcon="fas fa-info-circle kt-font-info"
            size="md"
          ></Illustration>
        </React.Fragment>
      )}
    </React.Fragment>
  );

  async function getAccountsReceivableAgingData() {
    const response = await getAccountsReceivableAgingReport();
    const { data } = response.data;
    setReceivableAgingList(data.receivableAgingList);
  }
}

export default AccountsReceivableAging;
